import axios from 'axios'
import { getJWT } from '../utils/functions'

const clinicvuBaseURL = process.env.REACT_APP_BACKEND

const requestFunction = async (config) => {
  const token = await getJWT().catch(() => {
    window.location.reload(false)
  })
  if (token) {
    config.headers.common.Authorization = 'Bearer ' + token
  }
  return config
}

const errorFunction = async (error) => {
  // Do something with request error
  console.log(error)
  return Promise.reject(error)
}

const headers = {
  'Content-Type': 'application/json'
}

const clinicvuInstance = axios.create({
  baseURL: clinicvuBaseURL,
  timeout: 30000,
  headers
})

clinicvuInstance.interceptors.request.use(requestFunction, errorFunction)

export { clinicvuInstance }
